import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Invoice } from 'src/app/shared/models/invoice.interface';
import { ExportCertificateService } from 'src/app/services/export-certificate/export-certificate.service';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';

@Component({
  selector: 'app-invoice-export-certificate',
  templateUrl: './invoice-export-certificate.component.html',
  styleUrls: ['./invoice-export-certificate.component.scss']
})
export class InvoiceExportCertificateComponent extends DestructorComponent implements OnInit, OnDestroy {
  @Input() invoice!: Invoice;
  @Input() showInvoiceHeader: boolean = true;

  certificate: any = null;
  settings: any;
  isLoading: boolean = false;
  hasError: boolean = false;
  errorMessage: string = '';

  constructor(
    private _exportCertificateService: ExportCertificateService,
    private _globalStateService: GlobalStateService
  ) {
    super();
  }

  ngOnInit(): void {
    this._globalStateService.GetSetting().subscribe((res: any) => {
      this.settings = res?.contacts?.english;
    });
    this.loadCertificate();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  /**
   * Load export certificate data for the invoice's vehicle
   */
  private loadCertificate(): void {
    if (!this.invoice?.vehicle?._id) {
      this.hasError = true;
      this.errorMessage = 'No vehicle information found for this invoice.';
      return;
    }

    this.isLoading = true;
    this.hasError = false;

    this.subscriptions.push(
      this._exportCertificateService.GetData('1', '', {
        vehicle_id: this.invoice.vehicle._id,
        paginate: false
      }).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          if (response.status && response.data && response.data.length > 0) {
            // Get the first certificate for this vehicle
            this.certificate = response.data[0];
          } else {
            this.hasError = true;
            this.errorMessage = 'No export certificate found for this vehicle.';
          }
        },
        error: (error: any) => {
          this.isLoading = false;
          this.hasError = true;
          this.errorMessage = 'Failed to load export certificate. Please try again.';
          console.error('Error loading export certificate:', error);
        }
      })
    );
  }

  /**
   * Get current year
   */
  getCurrentYear(): string {
    return new Date().getFullYear().toString();
  }

  /**
   * Get current month
   */
  getCurrentMonth(): string {
    return (new Date().getMonth() + 1).toString().padStart(2, '0');
  }

  /**
   * Get current day
   */
  getCurrentDay(): string {
    return new Date().getDate().toString().padStart(2, '0');
  }

  /**
   * Format date to DD/MM/YYYY
   */
  formatDate(dateString: string | null): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  /**
   * Format currency
   */
  formatCurrency(amount: number | null, currency: string | null = 'USD'): string {
    if (!amount || amount === 0) return '';
    const curr = currency || 'USD';
    return `${curr} ${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}

